const Shared = require("Sources/shared");
const Carousel = require("Sources/components/figurine-carousel");
const LanguageManager = require("Sources/services/language-manager");
const Utils = require("Sources/utils/utils");

require("Styles/pages/figurines.scss");

$(function()
{
  Shared.init();
  FigurinesPage.init();
});

var FigurinesPage = {};

((FigurinesPage) =>
{
  var element = $(".carousel-wrapper");
  var carousel;

  var startAt = "karla";
  if(window.location.hash !== "") startAt = window.location.hash;

  FigurinesPage.init = function()
  {
    carousel = new Carousel({
      element: element,
      centered: true,
      clickCallBack: onCarouselClicked,
      startAt: startAt
    });

    element.on("afterChange", function(event, slick, currentSlide)
    {
      var el = $(slick.$slides[currentSlide]).find(".figurine-slide");
      var id = el.data("figurine-id");
      var sex = el.data("figurine-sex");

      $(".figurines-portrait-figurine").hide();
      $(".figurines-portrait-figurine." + id).show();

      $("#figurines-passport-name").text(LanguageManager.getValueForKey("figurines." + id + ".name"));
      $("#figurines-passport-description").html(LanguageManager.getValueForKey("figurines." + id + ".description"));
      $("#figurines-passport-animal").text(LanguageManager.getValueForKey("figurines." + id + ".animal"));
      $("#figurines-passport-female").text(LanguageManager.getValueForKey("figurines." + id + ".female"));
      $("#figurines-passport-male").text(LanguageManager.getValueForKey("figurines." + id + ".male"));
      $("#figurines-passport-age").text(LanguageManager.getValueForKey("figurines." + id + ".age"));
      $("#figurines-passport-hobby").text(LanguageManager.getValueForKey("figurines.hobby.label") + LanguageManager.getValueForKey("figurines." + id + ".hobby"));
      $("#figurines-passport-relation").text(LanguageManager.getValueForKey("figurines.relation.label") + LanguageManager.getValueForKey("figurines." + id + ".relation"));
      $("#figurines-passport-food").text(LanguageManager.getValueForKey("figurines.food.label") + LanguageManager.getValueForKey("figurines." + id + ".food"));

      if(sex === "male")
      {
        $("#figurines-passport-female-symbol").removeClass("inactive").addClass("inactive");
        $("#figurines-passport-male-symbol").removeClass("inactive");
        $("#figurines-passport-female").removeClass("inactive").addClass("inactive");
        $("#figurines-passport-male").removeClass("inactive");
      }
      else
      {
        $("#figurines-passport-female-symbol").removeClass("inactive");
        $("#figurines-passport-male-symbol").removeClass("inactive").addClass("inactive");
        $("#figurines-passport-female").removeClass("inactive");
        $("#figurines-passport-male").removeClass("inactive").addClass("inactive");
      }

      window.location.hash = id;

    });


    Utils.ImageSVGToSVG();
  };

  function onCarouselClicked(e)
  {
    var el = $(e.currentTarget).find(".figurine-slide");

    window.location.hash = el.data("figurine-id");
  }

})(FigurinesPage);



// WEBPACK FOOTER //
// ./app/js/entries/figurines.js